import { computed } from 'vue'
import { useStore } from 'vuex'

export function usePartnerFees() {
  const store = useStore()

  const lowerFee = computed(() => store.getters['partnerSettings/lowerFee'])
  const upperFee = computed(() => store.getters['partnerSettings/upperFee'])
  const isLoading = computed(() => store.getters['partnerSettings/loading'])

  async function fetchPartnerSettings(coin) {
    await store.dispatch('partnerSettings/getPartnerSettings', coin)
  }

  return {
    lowerFee,
    upperFee,
    isLoading,
    fetchPartnerSettings,
  }
}
